export default __webpack_public_path__ + "images/e22b9eb2aed71701b8c8c3a1f09a6c17.svg";